













import { Vue, Component } from 'vue-property-decorator'
import { config } from '@/setup/config'
import { Product } from '../../reusable/types'
import ProductComponent from './product.vue'

@Component({
  components: {
    ProductComponent
  },
  i18n: {
    messages: {
      en: {
        'productsTitle': 'Select a project',
      },
      ru: {
        'productsTitle': 'Выберите продукт'
      }
    }
  }
})
export default class ProductsPage extends Vue {
  get products (): Product[] {
    return config.products
  }
}
